(function () {
  'use strict';

  if (window.FellinoraOfferCardsLoaded) {
    return;
  }

  window.FellinoraOfferCardsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canTilt = window.matchMedia('(hover: hover) and (pointer: fine)');
  var canReveal = window.matchMedia('(min-width: 720px)');

  function setRevealDelays(section) {
    var lines = section.querySelectorAll('[data-foc-line]');
    var revealItems = section.querySelectorAll('[data-foc-reveal]');

    lines.forEach(function (line, index) {
      line.style.setProperty('--foc-delay', 130 + index * 115 + 'ms');
    });

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--foc-delay', Math.min(index * 110, 560) + 'ms');
    });
  }

  function initReveal(section) {
    setRevealDelays(section);

    if (reduceMotion.matches || !canReveal.matches || !('IntersectionObserver' in window)) {
      section.classList.add('foc-is-visible');
      return;
    }

    section.classList.add('foc-reveal-enabled');

    var fallbackTimer;
    var reveal = function () {
      section.classList.add('foc-is-visible');

      if (fallbackTimer) {
        window.clearTimeout(fallbackTimer);
      }
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        reveal();
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.01,
      rootMargin: '0px 0px -4% 0px'
    });

    observer.observe(section);
    fallbackTimer = window.setTimeout(reveal, 1800);
  }

  function resetTilt(card) {
    card.style.setProperty('--foc-tilt-x', '0deg');
    card.style.setProperty('--foc-tilt-y', '0deg');
    card.style.setProperty('--foc-glow-x', '50%');
    card.style.setProperty('--foc-glow-y', '0%');
  }

  function initTilt(section) {
    if (reduceMotion.matches || !canTilt.matches) {
      return;
    }

    section.querySelectorAll('[data-foc-card]').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width;
        var y = (event.clientY - rect.top) / rect.height;
        var rotateY = (x - 0.5) * 6;
        var rotateX = (0.5 - y) * 5;

        card.style.setProperty('--foc-tilt-x', rotateX.toFixed(2) + 'deg');
        card.style.setProperty('--foc-tilt-y', rotateY.toFixed(2) + 'deg');
        card.style.setProperty('--foc-glow-x', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--foc-glow-y', (y * 100).toFixed(1) + '%');
      });

      card.addEventListener('pointerleave', function () {
        resetTilt(card);
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.focInitialized === 'true') {
      return;
    }

    section.dataset.focInitialized = 'true';
    initReveal(section);
    initTilt(section);
  }

  function init() {
    document.querySelectorAll('[data-foc-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-foc-section]')
      ? event.target
      : event.target.querySelector('[data-foc-section]');
    initSection(section);
  });
})();
